
import { CLIENT_ERROR, parsingErrorResponse } from "@/app/infrastructures/misc/Utils";
import { ClientRegistrationController } from "@/app/ui/controllers/ClientRegistrationController";
import { MainAppController } from "@/app/ui/controllers/MainAppController";
import { EditInsuranceRateApiRequest } from "@/data/payload/api/ClientRegistrationApiRequest";
import { ErrorMessageEntities } from "@/domain/entities/MainApp";
import { Options, prop, Vue } from "vue-class-component";

class Props {
  modelValue = prop<any>({
    required: true,
    type: Object
  });
  error = prop<any>({
    required: true,
  });
  clientId = prop<number>({
    required: true,
    type: Object
  });
  clientName = prop<string>({
    required: true,
    type: Object
  });
}

@Options({
  emits: ["onClosePopup", "onSuccessEdit"]
})

class ModalChangeInsurance extends Vue.with(Props) {
  created() {
    this.initializeInsurances();
  }

  initializeInsurances() {
    this.insurances = [
      {
        name: this.$t("clientManagement.changeInsuranceModal.selectInsuranceType").toString(),
        value: "",
      },
      {
        name: this.$t("clientManagement.changeInsuranceModal.customRates").toString(),
        value: "custom",
      },
      {
        name: this.$t("clientManagement.changeInsuranceModal.bundlingNoInsuranceFee").toString(),
        value: "bundling",
      },
      {
        name: this.$t("clientManagement.changeInsuranceModal.tieringRetail").toString(),
        value: "tiering",
      },
    ];
  }
  

  onHidePopup() {
    this.$emit("onClosePopup", false);
    this.modelValue.insurance = "";
  }


  get isValidChangeInsurance() {
    return (this.modelValue.insurance &&
    !this.error.customRates);
  }

  isOpenSelectInsurance = false;

  insurances: any[] = [];
  onOpenSelectInsurance() {
    this.isOpenSelectInsurance = true;
  }
  onCloseSelectInsurance() {
    this.isOpenSelectInsurance = false;
  }
  async onSelectInsurance(_: string, value: string) {
    this.onCloseSelectInsurance();
    this.modelValue.insurance = value;
    this.modelValue.customRates = 2;
    await this.$emit("update:modelValue", {
      ...this.modelValue,
      insurance: value,
      customRates: 2,
    });
    this.error.customRates = false;
    await this.$emit("update:error", { ...this.error, customRates: false });
  }

  errorCaptionCustomRates = "";
  validateCustomRates(value: string) {
    value = `0,${value}`.replace(/,/g, ".");
    if (Number(value) < 0.2) {
      this.error.customRates = true;
      this.errorCaptionCustomRates =
        this.$t("clientManagement.changeInsuranceModal.customRatesMin").toString();
      this.$emit("update:error", { ...this.error, customRates: true });
      return;
    } else if (Number(value) > 0.99) {
      this.error.customRates = true;
      this.errorCaptionCustomRates =
        this.$t("clientManagement.changeInsuranceModal.customRatesMax").toString();
      this.$emit("update:error", { ...this.error, customRates: true });
      return;
    } else {
      this.error.customRates = false;
      this.$emit("update:error", { ...this.error, customRates: false });
      return;
    }
  }

  get insurancePercentage() {
    return this.modelValue.insurance === "custom"
      ? Number(Number("0." + this.modelValue.customRates).toFixed(2))
      : 0;
  }

  async onSaveInsurance() {
    const payload = new EditInsuranceRateApiRequest(
      this.clientId,
      this.modelValue.insurance !== 'tiering' ? this.modelValue.insurance : '',
      this.insurancePercentage
    )
    MainAppController.showLoading();
    await ClientRegistrationController.editClientInsuranceRate(payload)
      .then(() => {
        this.onHidePopup();
        MainAppController.setSnackbarMessage(
          this.$t("clientManagement.changeInsuranceModal.success", { clientName: this.clientName }).toString()
        );
        MainAppController.setSnackbarTimeout(2000);
        MainAppController.setSnackbar(true);
        this.$emit("onSuccessEdit");
      })
      .catch(err => {
        const message = err.response.data.message;
        MainAppController.showErrorMessage(
        typeof message === "string"
          ? new ErrorMessageEntities({
              message: message,
              title: this.$t("clientManagement.changeInsuranceModal.serverError").toString(),
              type: CLIENT_ERROR
            })
          : parsingErrorResponse(
            err,
            this.$t("clientManagement.changeInsuranceModal.failed", { clientName: this.clientName }).toString()
          )
        );
      })
      .finally(() => {
        MainAppController.closeLoading();
      });
  }

}
export default ModalChangeInsurance;
